






































































































































































/* eslint-disable */
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import Provisao from '@/store/Provisao'
import { unix } from 'moment'
import Conciliacao from '@finx/web-repository/src/apis/Backoffice/services/Conciliacao'
import { Apis, Factories } from '@finx/web-repository/'
import { CalculadoraProvisao } from '@finx/web-repository/src/types/Provisao'

@Component
export default class ComponentProvisaoDadosIniciais extends Vue {
  @Prop(Boolean) show
  comboSelected: any[] = []
  aplicarAnestisista: Boolean = false
  aplicaInstrumentador: Boolean = false

  async changeProfissionalAuxiliares(index) {
    await this.changeProfissionalCore(this.funcao.auxiliares["auxiliar" + (index + 1)], 'auxiliares.auxiliar' + (index + 1), (index + 1))
    this.clearProfissionalExecutanteAuxiliar(this.funcao.auxiliares["auxiliar" + (index + 1)], (index + 1))

    if (this.getInativo.length > 0) {
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'success')
    } else {
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'primary')
    }

    Provisao.dispatch('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', false)
    Provisao.dispatch('HABILITAR_ENVIO_PROVISAO')
    Provisao.dispatch('CALCULADORA_PROVISAO')
  }

  async changeProfissional(selected, descricaoFuncao, codigoFuncao) {

    await this.changeProfissionalCore(selected, descricaoFuncao, codigoFuncao)
    this.clearProfissionalExecutante(selected, descricaoFuncao)
    if (this.getInativo.length > 0) {
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'success')
    } else {
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'primary')
    }

    Provisao.dispatch('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', false)
    Provisao.dispatch('HABILITAR_ENVIO_PROVISAO')
    Provisao.dispatch('CALCULADORA_PROVISAO')
  }

  async changeProfissionalCore(selected, name, funcao) {
    const item = this.comboSelected[name]

    if (item !== null && item !== undefined) {
      this.funcao.profissionaisExecutantes.map((p) => {
        if (p.id === item.id) {
          p.status = true
          p.funcao = ''
          this.comboSelected[name] = ''
        }
      })
    }

    if (selected !== null && selected.id !== null) {
      this.funcao.profissionaisExecutantes.map((p) => {
        if (p.id === selected.id) {
          p.status = false
          p.funcao = funcao
          this.comboSelected[name] = p
        }
      })
    }
  }

  clearProfissionalExecutanteAuxiliar(selected, index) {
    if (selected === null || selected === '') {
      this.funcao.profissionaisExecutantes.map((p) => {
        if (p.funcao === index) {
          p.status = true
        }
      })
      return
    }

    const clear = this.funcao.profissionaisExecutantes.filter(p => p.nome === selected.nome)

    if (clear.length <= 0) {
      switch (index) {
        case 1:
          this.funcao.auxiliares.auxiliar1 = ''
          break
        case 2:
          this.funcao.auxiliares.auxiliar2 = ''
          break
        case 3:
          this.funcao.auxiliares.auxiliar3 = ''
          break
        case 4:
          this.funcao.auxiliares.auxiliar4 = ''
          break
        default:
          break
      }
    }

    for (let i = 0; i < this.funcao.profissionaisExecutantes.length; i++) {
      if (!this.isCirurgiaoSelect(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isInstrumentadorSelect(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isAnestesistaSelect(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isAuxiliar1Select(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isAuxiliar2Select(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isAuxiliar3Select(this.funcao.profissionaisExecutantes[i].nome)
       && !this.isAuxiliar4Select(this.funcao.profissionaisExecutantes[i].nome)) {
        this.funcao.profissionaisExecutantes[i].status = true
        this.funcao.profissionaisExecutantes[i].funcao = ''
      }
    }
  }

  clearProfissionalExecutante(selected, name) {

    if(selected === null || selected === '') {
      this.funcao.profissionaisExecutantes.map(p => {
        var codigoFuncao = this.getFuncaoCodigo(name)
        if(p.funcao === codigoFuncao) {
          p.status = true
          p.funcao = ''
        }
      })
      return
    }

    var clear = this.funcao.profissionaisExecutantes.filter(p => p.nome === selected.nome)
      if(clear.length <= 0) {
        this.funcao[name] = ''
    }

    for (let i = 0; i < this.funcao.profissionaisExecutantes.length; i++) {

      if (!this.isCirurgiaoSelect(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isInstrumentadorSelect(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isAnestesistaSelect(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isAuxiliar1Select(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isAuxiliar2Select(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isAuxiliar3Select(this.funcao.profissionaisExecutantes[i].nome) &&
          !this.isAuxiliar4Select(this.funcao.profissionaisExecutantes[i].nome)) {
        this.funcao.profissionaisExecutantes[i].status = true
        this.funcao.profissionaisExecutantes[i].funcao = ''
      }
    }
  }

  isCirurgiaoSelect(nomeProfissionalExecutante) {
    if (this.funcao.cirurgiao === null)
      return false
    else if (this.funcao.cirurgiao === '')
      return false
        else if (this.funcao.cirurgiao.nome === nomeProfissionalExecutante)
          return true
  }

  isInstrumentadorSelect(nomeProfissionalExecutante) {
    if (this.funcao.instrumentador === null)
      return false
    else if (this.funcao.instrumentador === '')
      return false
        else if (this.funcao.instrumentador.nome === nomeProfissionalExecutante)
          return true
  }

  isAnestesistaSelect(nomeProfissionalExecutante) {
    if (this.funcao.anestesista === null)
      return false
    else if (this.funcao.anestesista === '')
      return false
        else if (this.funcao.anestesista.nome === nomeProfissionalExecutante)
          return true
  }

  isAuxiliar1Select(nomeProfissionalExecutante) {
    if (this.funcao.auxiliares === null)
      return false
    else if (this.funcao.auxiliares === '')
      return false
      else if (this.funcao.auxiliares.auxiliar1 === null)
        return false
          else if (this.funcao.auxiliares.auxiliar1 === '')
          return false
            else if (this.funcao.auxiliares.auxiliar1.nome === nomeProfissionalExecutante)
            return true
  }

  isAuxiliar2Select(nomeProfissionalExecutante) {
    if (this.funcao.auxiliares === null)
      return false
    else if (this.funcao.auxiliares === '')
      return false
      else if (this.funcao.auxiliares.auxiliar2 === null)
        return false
          else if (this.funcao.auxiliares.auxiliar2 === '')
          return false
            else if (this.funcao.auxiliares.auxiliar2.nome === nomeProfissionalExecutante)
            return true
  }

  isAuxiliar3Select(nomeProfissionalExecutante) {
    if (this.funcao.auxiliares === null)
      return false
    else if (this.funcao.auxiliares === '')
      return false
      else if (this.funcao.auxiliares.auxiliar3 === null)
        return false
          else if (this.funcao.auxiliares.auxiliar3 === '')
          return false
            else if (this.funcao.auxiliares.auxiliar3.nome === nomeProfissionalExecutante)
            return true
  }

  isAuxiliar4Select(nomeProfissionalExecutante) {
    if (this.funcao.auxiliares === null)
      return false
    else if (this.funcao.auxiliares === '')
      return false
      else if (this.funcao.auxiliares.auxiliar4 === null)
        return false
          else if (this.funcao.auxiliares.auxiliar4 === '')
          return false
            else if (this.funcao.auxiliares.auxiliar4.nome === nomeProfissionalExecutante)
            return true
  }

  getFuncaoCodigo(funcao) {
    switch (funcao) {
      case 'cirurgiao':
        return 0
      case 'instrumentador':
        return 5
      case 'anestesista':
        return 6
      default:
        return ''
    }
  }

  get getAtivo() {
    return this.funcao.profissionaisExecutantes.filter(p => p.status === true)
  }

  get getInativo() {
    return this.funcao.profissionaisExecutantes.filter(p => p.status === false)
  }

  getDescricaoAuxiliares(index) {
    return `${index + 1}º auxiliar`
  }

  async getProfissionalExecutantes() {
    const { user } = this
    const request = await Apis.Contratos
      .ProfissionaisExecutantes.getProfissionalExecutanteByContratoId(this.provisao.contratoId)
    const success = Factories.Apis.success(request)

    if (success) {
      Provisao.dispatch('SET_PROFISSIONAIS_EXECUTANTES', request.data)
    }
  }

  isEnableVisualizarFuncao(funcao) {
    if (funcao === 'anestesista' && !this.aplicarAnestisista) {
      return false
    }

    if (funcao === 'instrumentador' && !this.aplicaInstrumentador) {
      return false
    }

    return true
  }

  get isGestor() {
    return Provisao.getters.PERFIL_PROFISSIONAL_EXECUTANTE.isGestor
  }

  get user() {
    return Provisao.getters.USER
  }

  get showProvisaoFuncao(): Boolean {
    return Provisao.getters.DIALOG_FUNCAO
  }

  set showProvisaoFuncao(newValue) {
    Provisao.commit('DIALOG_FUNCAO', newValue)
  }

  get totalProvisao() {
    return Provisao.getters.PROVISAO_VALOR_TOTAL
  }

  get provisao() {
    return Provisao.getters.PROVISAO
  }

  get getQntAuxiliares() {
    if (this.procedimentos.length > 0) {
      const p = this.procedimentos.reduce((prev, current) => prev.quantidadeAuxiliarPermitido > current.quantidadeAuxiliarPermitido ? prev : current)
      this.aplicarAnestisista = p.aplicaAnestesico
      this.aplicaInstrumentador = p.aplicaInstrumentador

      const number = p.quantidadeAuxiliarPermitido
      return Array.from(new Array(number), (x, y) => y)
    }

    return []
  }

  get calculadora() {
    return Provisao.getters.CALCULADORA
  }

  get funcao() {
    return Provisao.getters.FUNCAO
  }

  get procedimentos() {
    return Provisao.getters.PROCEDIMENTOS
  }

  @Watch('show')
  watchShow(newValue) {
    if (newValue && this.funcao.profissionaisExecutantes.length === 0) {
      this.getProfissionalExecutantes()
    }
  }

  mounted() { }

  get isEnableSave() {
    return this.getInativo.length > 0
  }

  @Emit('close')
  close() {}
}
